"use client";
import { Elements } from "@stripe/react-stripe-js";
import React, { useEffect, useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import AddNewCardForm from "../components/AddNewCardForm";

const AddNewCard = () => {
    const [clientSecret, setClientSecret] = useState("");
    const stripePromise = loadStripe(
        "pk_test_51QKnOZK0DzdlOO6IoRy2ZXy6Wnl17P9LRM2p177Grh6BApETVMef2kgthqfGJTXD8xOfROUMmySTtvV34GlDdxcP00ccf2R2Wi"
    );
    useEffect(() => {
        setClientSecret("client_secret");
    }, []);

    return (
        <div>
            <Elements stripe={stripePromise}>
                {clientSecret && <AddNewCardForm />}
            </Elements>
        </div>
    );
};

export { AddNewCard };